<template>
  <div class="content-item flex">
    <div class="content-item-label">接种针次</div>
    <div class="inoculation">
      <el-input
        size="small"
        v-model="num"
        :controls="false"
        maxlength="50"
        controls-position="right"
      ></el-input
      >针
    </div>
  </div>
</template>

<script>
export default {
  name: "inoculationNum",
  props: ["value"],
  computed: {
    num: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  align-items: center;
  .inoculation {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    :deep(.el-input .el-input__inner) {
      width: 105px !important;
      padding-right: 15px !important;
    }
    :deep(.el-input.el-input--small) {
      width: 120px !important;
    }
  }
}
</style>
